import axios from 'axios';
import { Fragment, Component } from 'react';
import { withRouter } from 'react-router-dom';
import { get, assign, capitalize } from 'lodash-es';
import * as rq from 'constants/helpCenter';

import {
  getCollections,
} from 'constants/helpCenter';
import DropdownInput from 'components/DropdownInput';
import is from 'helpers/is';
import SearchForm from '../SearchForm';
import CollectionItem from './components/CollectionItem';

import { HELP_CATEGOTY_ICON_MAP } from './constants';

const COUNT_DUMMY_PLACEHOLDERS = 3;
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = { isFetched: false };
    this.collections = Array.from(
      { length: COUNT_DUMMY_PLACEHOLDERS },
      () => ({})
    );
  }

  componentDidMount() {
    getCollections().then(
      ({
        data: {
          collections: { items },
        },
      }) => {
        this.collections = [];
        items.forEach((item) => {
          const categoryWithIcon = HELP_CATEGOTY_ICON_MAP.find(
            (collection) => collection.id === item.id
          );

          if (categoryWithIcon) item.icon = categoryWithIcon.icon;

          if (item.visibility === 'public' || !is().prod) {
            this.collections.push(item);
          }
        });

        this.getArticles();
      }
    );
  }

  async getData(type, payload) {
    const {
      data: {
        [type]: { items },
      },
    } = await rq[`get${capitalize(type)}`](payload);

    return items;
  }

  async getCategoriesData(collectionId) {
    const categories = await this.getData('categories', collectionId);
    const NotEmptyCategories = categories.filter((category) => category.publishedArticleCount > 0);

    if (NotEmptyCategories.length === 0) return null;

    const articles = await this.getData('articles', NotEmptyCategories[0].id);

    return {
      ...NotEmptyCategories[0],
      articles: articles.filter((item) => item.status === 'published'),
    };
  }

  getArticles = () => {
    axios
      .all(
        this.collections.map((collection) =>
          this.getCategoriesData(collection.id).then((data) => ({
            ...collection,
            firstArticle: get(data, 'articles[0]'),
          }))
        )
      )
      .then((collections) => {
        this.collections.map((collection, index) =>
          assign(collection, collections[index])
        );
        this.setState({ isFetched: true });
      });
  };

  render() {
    return (
      <Fragment>
        <section className="section section_search_1">
          <div className="wrapper">
            <div className="section__inner">
              <div className="section__header-wrap _mb-37 _mb-note-94 _mb-phone-53">
                <h1 className="title title_white section__title">
                  Help Center
                </h1>
              </div>
              <div className="search _mb-31 _mb-note-35 _mb-phone-20">
                <SearchForm history={this.props.history}>
                  {(options) => (
                    <DropdownInput
                      {...options}
                      placeholder="Search our Help Center"
                      className="search__input"
                    />
                  )}
                </SearchForm>
              </div>
              <p className="text text_white section__text">
                Tips of the day: Getting started, Starting a trial, Choosing the
                right template
              </p>
            </div>
          </div>
        </section>
        <section className="section section_search_2">
          <div className="wrapper">
            <div className="row">
              {this.collections.map((collection, index) => (
                <CollectionItem
                  key={index}
                  collection={collection}
                  history={this.props.history}
                />
              ))}
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}

export default withRouter(Home);
